// eslint-disable-next-line import/prefer-default-export
export const SET_CURRENCY = 'SET_CURRENCY';
